import { NgModule } from '@angular/core';
import { ModelMetaDataFormComponent } from './model-meta-data-form.component';
import { CommonModule } from '@angular/common';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateSelectModule } from '@fgb/portal-component-library/src/lib/shared/date-select';
import { SelectCountryModule } from '@fgb/portal-component-library/src/lib/shared/select-country';
import { SelectRegionModule } from '@fgb/portal-component-library/src/lib/shared/select-region';

@NgModule({
    declarations: [
        ModelMetaDataFormComponent
    ],
    imports: [
        CommonModule,
        FGBSharedModule,
        FormsModule,
        ReactiveFormsModule,
        DateSelectModule,
        SelectCountryModule,
        SelectRegionModule
    ],
    exports: [
        ModelMetaDataFormComponent
    ]
})  
export class ModelMetaDataFormModule{}